"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnixTimestampFromKSTTime = exports.changeKSTToLocalTime = exports.changeLocalToKSTTime = exports.zeroSecTimeFormat = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.zeroSecTimeFormat = 'YYYY-MM-DD[T]HH:mm:[00]';
function changeLocalToKSTTime(localTime, timeFormat) {
    return (0, moment_timezone_1.default)(localTime)
        .tz('Asia/Seoul')
        .format(timeFormat || exports.zeroSecTimeFormat);
}
exports.changeLocalToKSTTime = changeLocalToKSTTime;
function changeKSTToLocalTime(korTime, timeFormat) {
    if (korTime)
        return moment_timezone_1.default
            .utc(korTime)
            .subtract(9, 'hours')
            .local()
            .format(timeFormat || exports.zeroSecTimeFormat);
    else
        return '';
}
exports.changeKSTToLocalTime = changeKSTToLocalTime;
function getUnixTimestampFromKSTTime(korTime) {
    return Number(moment_timezone_1.default.utc(korTime).subtract(9, 'hours').format('x'));
}
exports.getUnixTimestampFromKSTTime = getUnixTimestampFromKSTTime;
